import { uniq } from 'lodash';
import { NetImpactRating } from '../../../../../../../common/model/output/scores/ratings/types';

export interface RatingDatum {
  rating: NetImpactRating;
  ratioThreshold: number;
  percentileThreshold: number;
}

const ratingData: RatingDatum[] = [
  {
    rating: NetImpactRating.AAA,
    ratioThreshold: 0.716,
    percentileThreshold: 0.97,
  },
  {
    rating: NetImpactRating.AA_PLUS,
    ratioThreshold: 0.648,
    percentileThreshold: 0.925,
  },
  {
    rating: NetImpactRating.AA,
    ratioThreshold: 0.543,
    percentileThreshold: 0.858,
  },
  {
    rating: NetImpactRating.A_PLUS,
    ratioThreshold: 0.416,
    percentileThreshold: 0.756,
  },
  {
    rating: NetImpactRating.A,
    ratioThreshold: 0.269,
    percentileThreshold: 0.604,
  },
  {
    rating: NetImpactRating.BBB,
    ratioThreshold: 0.001,
    percentileThreshold: 0.382,
  },
  {
    rating: NetImpactRating.BB,
    ratioThreshold: -0.386,
    percentileThreshold: 0.225,
  },
  {
    rating: NetImpactRating.B,
    ratioThreshold: -0.969,
    percentileThreshold: 0.123,
  },
  {
    rating: NetImpactRating.CCC,
    ratioThreshold: -2.02,
    percentileThreshold: 0.0559,
  },
  {
    rating: NetImpactRating.CC,
    ratioThreshold: -3.96,
    percentileThreshold: 0.0109,
  },
  {
    rating: NetImpactRating.C,
    ratioThreshold: -9999,
    percentileThreshold: 0.0,
  },
];

export const ratings = ratingData.map(d => d.rating);
export const simpleRatings = uniq(ratingData.map(d => d.rating.replace('+', '')));

export function toCompanyNetImpactRating(ratio: number): NetImpactRating {
  for (const d of ratingData) {
    if (ratio >= d.ratioThreshold) {
      return d.rating;
    }
  }
  return NetImpactRating.C;
}

export function toSimpleCompanyNetImpactRating(ratio: number) {
  return toCompanyNetImpactRating(ratio).replace('+', '');
}
